import { configureStore } from '@reduxjs/toolkit';
import loginReducer from '../../../modules/users/redux/User.slice';
import newsReducer from '../../../modules/admin/news/redux/News.slice';
import eventsReducer from '../../../modules/admin/events/redux/Events.slice';
import jobsReducer from '../../../modules/admin/jobs/redux/Jobs.slice';
import formsReducer from '../../../modules/admin/form/redux/Forms.slice';
import documentReducer from '../../../modules/admin/documents/redux/Documents.slice';
import membersReducer from '../../../modules/admin/members/redux/Member.slice';
import groupsReducer from '../../../modules/admin/groups/redux/Groups.slice';
import notificationsReducer from '../../../modules/admin/notifications/redux/Notifications.slice';
import tagsReducer from '../../../modules/admin/tags/redux/Tags.slice';
import filesReducer from '../../../modules/admin/files/redux/Files.slice';
import feedItemReducer from '../../../modules/admin/feedItems/redux/FeedItem.slice';
import featuredFeedItemReducer from '../../../modules/admin/feedItems/redux/FeaturedItem.slice';
import communityReducer from '../../../modules/administrator/communities/redux/Community.slice';
import communityAdminReducer from '../../../modules/administrator/admin/redux/CommunityAdmin.slice';
import administratorReducer from '../../../modules/administrator/admin/redux/Administrator.slice';
import adminCommunityMemberReducer from '../../../modules/administrator/members/redux/AdminCommunityMembers.slice';
import analyticsReducer from '../../../modules/admin/analytics/redux/Analytics.slice';
import publicReducer from '../../../modules/users/redux/Public.slice';
import adminAnalyticsReduces from '../../../modules/administrator/analytics/redux/Communities.slice';
import adminSupportReducer from '../../../modules/administrator/support/redux/AdminSupport.slice';
import communitySupportReducer from '../../../modules/admin/support/redux/communitySupport.slice';
import settingsReducer from '../../../modules/admin/settings/redux/Settings.slice';
import dashboardReducer from '../../../modules/admin/dashboard/redux/Dashboard.slice';

const store = configureStore({
  reducer: {
    login: loginReducer,
    news: newsReducer,
    events: eventsReducer,
    jobs: jobsReducer,
    forms: formsReducer,
    documents: documentReducer,
    members: membersReducer,
    groups: groupsReducer,
    notifications: notificationsReducer,
    tags: tagsReducer,
    files: filesReducer,
    feedItem: feedItemReducer,
    featuredFeedItem: featuredFeedItemReducer,
    community: communityReducer,
    communityAdmin: communityAdminReducer,
    administrator: administratorReducer,
    analytics: analyticsReducer,
    communitySupport: communitySupportReducer,
    public: publicReducer,
    adminCommunityMembers: adminCommunityMemberReducer,
    adminAnalytics: adminAnalyticsReduces,
    adminSupport: adminSupportReducer,
    settings: settingsReducer,
    dashboard: dashboardReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
